"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapPresentationToV2 = exports.mapPresentationV2Response = exports.mapPresentationResponse = void 0;
const urls_1 = __importDefault(require("./urls"));
const ResourceClient_1 = require("./ResourceClient");
const FileUploadUtils_1 = require("./FileUploadUtils");
const ThemeClient_1 = require("./ThemeClient");
const mapPresentationResponse = (p) => ({
    id: p.id,
    name: p.name,
    applicationId: p.application_id,
    appVersionId: p.application_deployment_id,
    themeId: p.theme_id,
    applicationThumbnailUrl: p.application_thumbnail_url,
    thumbnailUrl: p.thumbnail_url,
    iconUrl: p.icon_url,
    applicationName: p.application_name,
    presentationProperties: p.presentation_properties,
    applicationVariables: p.application_vars,
    hasDynamicThumbnails: p.has_dynamic_thumbnails,
    duration: p.duration,
    sourceUrl: p.source_url,
    fileUploads: p.file_uploads
        ? p.file_uploads.map(FileUploadUtils_1.mapFileUploadResponse)
        : null,
    resource: (0, ResourceClient_1.mapResourceResponse)(p.resource),
    theme: p.theme_id && p.theme
        ? (0, ThemeClient_1.mapThemeResponse)(Object.assign(Object.assign({}, p.theme), { resource: p.resource }))
        : undefined,
});
exports.mapPresentationResponse = mapPresentationResponse;
const mapPresentationV2Response = (p) => ({
    id: p.id,
    name: p.name,
    duration: p.duration,
    applicationVariables: p.application_vars,
    applicationDeploymentId: p.application_deployment_id,
    themeId: p.theme_id,
    token: p.token,
    r: {
        resource: (0, ResourceClient_1.mapResourceV2Response)(p.r.resource),
        presentationsPlaylists: (p.r.presentations_playlists || []).map((item) => ({
            playlistId: item.playlist_id,
        })),
    },
});
exports.mapPresentationV2Response = mapPresentationV2Response;
const mapPresentationToV2 = (p) => {
    var _a, _b, _c, _d;
    return ({
        id: p.id,
        name: p.name,
        duration: (_a = p.duration) !== null && _a !== void 0 ? _a : 30,
        applicationVariables: p.applicationVariables,
        applicationDeploymentId: p.appVersionId,
        themeId: (_b = p.themeId) !== null && _b !== void 0 ? _b : null,
        token: p.token,
        r: {
            resource: {
                id: p.resource.id,
                profileId: p.resource.profile.id,
                domainId: (_d = (_c = p.resource.domain) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : null,
                parentFolderId: p.resource.parentFolderId,
                createdAt: p.resource.createdAt,
                updatedAt: p.resource.updatedAt,
                deletedAt: p.resource.deletedAt,
                r: {
                    tags: p.resource.r.tags,
                },
            },
            presentationsPlaylists: [],
        },
    });
};
exports.mapPresentationToV2 = mapPresentationToV2;
class PresentationClient {
    getPresentations(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            const isValidQueryParams = filter && filter.ids.length > 0;
            const filterQs = isValidQueryParams ? `?id=${filter === null || filter === void 0 ? void 0 : filter.ids.join(',')}` : '';
            const data = yield this.requestProtected({
                method: 'GET',
                url: `${urls_1.default.presentations()}${filterQs}`,
            });
            return data.map(exports.mapPresentationResponse);
        });
    }
    deletePresentation(id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestProtected({
                method: 'DELETE',
                url: urls_1.default.presentation(id),
            });
        });
    }
    updatePresentation(id, params) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const { presentation, file_uploads: fileUploads, } = yield this.requestProtected({
                method: 'PATCH',
                url: urls_1.default.presentation(id),
                body: {
                    name: params.name,
                    application_deployment_id: params.appVersionId,
                    theme_id: params.themeId,
                    application_vars: params.applicationVariables,
                    duration: params.duration,
                    resource: params.resource && {
                        r: ((_a = params.resource) === null || _a === void 0 ? void 0 : _a.r) && {
                            tags: (_b = params.resource.r.tags) === null || _b === void 0 ? void 0 : _b.map(ResourceClient_1.mapCreateTag),
                        },
                    },
                },
            });
            return [
                (0, exports.mapPresentationResponse)(presentation),
                (0, FileUploadUtils_1.mapNewFileUploadsResponse)(fileUploads),
            ];
        });
    }
    createPresentation(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { presentation, file_uploads: fileUploads, } = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.presentations(),
                body: {
                    name: params.name,
                    application_deployment_id: params.appVersionId,
                    theme_id: params.themeId,
                    application_vars: params.applicationVariables,
                    duration: params.duration,
                },
            });
            return [
                (0, exports.mapPresentationResponse)(presentation),
                (0, FileUploadUtils_1.mapNewFileUploadsResponse)(fileUploads),
            ];
        });
    }
    movePresentationToFolder(presentationId, folderId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.presentationMoveToFolder(presentationId),
                body: {
                    folder_id: folderId,
                },
            });
        });
    }
    copyPresentation(presentationId, params = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.presentationCopy(presentationId),
                body: {
                    name: params.name,
                },
            });
            return (0, exports.mapPresentationResponse)(data);
        });
    }
    getPresentationsList(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.getPresentationsList(query),
            });
            return data;
        });
    }
}
exports.default = PresentationClient;
